export const isValidVariable = (val) => val !== null && val !== undefined;
let language = window.localStorage.getItem("i18nextLng");
export const convertAmountToFrontend = (val) =>
  isValidVariable(val) && val.toLocaleString(language);
export const convertNumberToFrontend = ({
  num = null,
  digit = 2,
  roundUp = false,
  addZero = true,
  lang = language,
} = {}) => {
  // değer null ise
  if (num === null) {
    return null;
  }

  // değer rakamsal ifade değilse

  if (isNaN(num) || !isValidVariable(digit)) {
    return num;
  }

  const floatSeperator = [LANG_VALUES.TR,LANG_VALUES.TRL].includes(lang) ? "," : ".";

  const numArray = String(num).split(".");

  let baseVal = isValidVariable(numArray?.[0]) ? Number(numArray[0]) : 0;

  let decimalVal = isValidVariable(numArray?.[1]) ? numArray[1] : 0;

  // ondalık değer korunacak

  if (digit === false) {
    return `${convertBaseNumber(baseVal)}${floatSeperator}${decimalVal}`;
  }

  if (roundUp && decimalVal > 0 && String(decimalVal).length > digit) {
    // yukarı yuvarlama açık,

    // data'da gelen ondalık basamak sayısı, ekranda görüntülenmek istenen oondalık basamak sayısından büyük

    const targetDecimal = Number(String(decimalVal).slice(0, digit)); // hedeflenen ondalık alan

    const outDecimal = Number(String(decimalVal).slice(digit)); // dışarda kalan ondalık alan

    const isRoundUpExist = Number(String(outDecimal).slice(0, 1)) >= 5; // yukarı yuvarlama yapılacaksa true olacak

    const resultDecimal = isRoundUpExist ? targetDecimal + 1 : targetDecimal;

    // yuvarlanan rakam sınıra dayandığından dolayı, tamsayı alanının 1 arttırılması lazım

    if (String(targetDecimal).length !== String(resultDecimal).length) {
      baseVal += 1;

      decimalVal = 0;
    } else {
      decimalVal = resultDecimal;
    }
  }

  let strDecimal = String(decimalVal).slice(0, digit);

  strDecimal = addZero ? strDecimal.padEnd(digit, "0") : strDecimal;

  return `${convertBaseNumber(baseVal)}${floatSeperator}${strDecimal}`;
};

const convertBaseNumber = (value, lang = language) => {
  /*
    
          value='1234', lang='tr'         ->  1.234
    
          value='850ab', lang='tr'        ->  850ab
    
         
    
          value='1234', lang='en'         ->  1,234
    
          value='850ab', lang='en'        ->  850ab
    
        */

  if (value === null) {
    return null;
  }

  let result = String(value);

  const digitSeperator = [LANG_VALUES.TR,LANG_VALUES.TRL].includes(lang) ? "." : ",";

  if (isNaN(result)) {
    return result;
  }

  if (result.indexOf(".") !== -1) {
    result = String(result.split(".")[0]);
  }

  if (result.length > 3) {
    result = result.replace(/(\d)(?=(\d{3})+$)/g, `$1${digitSeperator}`);
  }

  return result;
};
export const LANG_VALUES = {
  TR: "tr",
  TRL:"tr-TR",
  EN: "en",
};